<div *ngIf="events">
  <p-table [value]="events"
           styleClass="p-datatable-sm"
           [paginator]="true"
           [rows]="10"
           [rowsPerPageOptions]="[5,10,25]"
           [showCurrentPageReport]="true"
           currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template pTemplate="header">
      <tr>
        <th>User</th>
        <th>Timestamp</th>
        <th>Message</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-event>
      <tr>
        <td class="text-xs text-500">{{ event.user }}</td>
        <td class="text-xs text-500">{{ event.timestamp | date:'short' }}</td>
        <td class="font-semibold text-sm">
          {{ event.message | slice: 0: 100 }}
          <ng-container *ngIf="event.message.length > 100">
            ... <a href="#" (click)="openMessageDialog(event.message); $event.preventDefault()">more</a>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3"
            class="text-center">No event logs found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog for showing full message -->
<p-dialog header="Full Message"
          [(visible)]="showDialog"
          position="bottom"
          [resizable]="true"
          [dismissableMask]="false"
          appendTo="body"
          [style]="{width: '50vw', height: '70vh'}"
          styleClass="event-log-dialog">

  <!-- Action section -->
  <div *ngIf="selectedMessage.action" class="mb-3 p-3 surface-ground border-round">
    <h3 class="font-bold text-lg">Action</h3>
    <p>{{ selectedMessage.action }}</p>
  </div>

  <!-- Diff items section -->
  <div *ngIf="selectedMessage.diffItems && selectedMessage.diffItems.length > 0" class="mb-3 p-3 surface-ground border-round">
    <h3 class="font-bold text-lg">Changes</h3>
    <div *ngFor="let item of selectedMessage.diffItems" class="mb-2 p-2 surface-card border-round shadow-1">
      <strong>{{ item.field }}:</strong>
      <div class="flex gap-2 mt-1">
        <div class="bg-red-100 p-2 flex-1 border-round border-1 border-red-200">{{ item.oldValue }}</div>
        <div class="flex align-items-center">→</div>
        <div class="bg-green-100 p-2 flex-1 border-round border-1 border-green-200">{{ item.newValue }}</div>
      </div>
    </div>
  </div>

  <!-- Original message -->
  <div class="p-3 surface-ground border-round">
    <h3 class="font-bold text-lg">Original Message</h3>
    <p class="whitespace-pre-line p-2 surface-card border-round">{{ selectedMessage.message }}</p>
  </div>
</p-dialog>
